import { jsx as _jsx } from "react/jsx-runtime";
import { BaseIcon } from "./BaseIcon";
// This SVG code is derived from Heroicons (https://heroicons.com)
// arrow-top-right-on-square-outline
export default function IconExternal(props) {
    return (_jsx(BaseIcon, Object.assign({ viewBox: "0 0 24 24" }, props, { children: _jsx("path", { fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", d: "M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" }) })));
}
